import React, { PureComponent } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import marked from 'marked'
import truncate from 'truncate'
import * as actions from '../../actions'
import searchDecode from '../../helpers/searchDecode'
import { doTrack } from '../../helpers/TaggingSerializer'
import conf from '../../config/config'

import LoadingWheel from '@argos/loading-wheel'
import Sidebar from '../../components/Sidebar/Sidebar'
import LoadingError from '../../components/LoadingError/LoadingError'
import Helmet from 'react-helmet'
import SearchBar from '../../components/SearchBar/SearchBar'

import './Search.scss'

class HelpFAQ extends PureComponent {
  static waitForDataServer (dispatch, params, req, res) {
    return Promise
      .all([
        dispatch(actions.fetchSidebarNav(true)),
        dispatch(actions.fetchFAQBySearch(params.searchTerm, params.pageNumber, true))
      ])
  }

  static waitForDataClient (store) {
    return (nextState, transition, callback) => {
      const { dispatch, getState } = store
      const { params } = nextState
      const faq = getState().faq

      const pageNumber = params.pageNumber ? params.pageNumber : 1

      if (faq.searchTerm === params.searchTerm && faq.searchPageNumber === pageNumber) {
        return callback()
      }

      dispatch(actions.fetchFAQBySearch(params.searchTerm, pageNumber))
        .then(() => { callback() })
        .catch(() => { callback() })
    }
  }

  constructor () {
    super()

    this.state = {
      searchTerm: ''
    }
  }

  componentWillReceiveProps (newProps) {
    if (this.props.routeParams.searchTerm !== newProps.routeParams.searchTerm || this.props.routeParams.pageNumber !== newProps.routeParams.pageNumber) {
      this.fireAnalytics()
    }
  }

  componentDidMount () {
    this.fetchData(this.props.routeParams.searchTerm, this.props.routeParams.pageNumber)
    this.fireAnalytics()
  }

  fireAnalytics = () => {
    if (window.digitalData) {
      window.digitalData.page.pageInfo.pageName = 'ar:help:faq:searchResults:'
      window.digitalData.page.pageInfo.templateTitle = 'FAQ_SearchResults'
    }

    doTrack('help_initialLoad')
  }

  fetchData = (newSearchTerm, newSearchPageNumber) => {
    const { actions, sidebar } = this.props
    if (!newSearchPageNumber) newSearchPageNumber = 1

    if (!sidebar.length) actions.fetchSidebarNav()
  }

  render () {
    const { error, sidebar, searchPageNumber, searchResults, searchTerm, searchTotalResults, loading } = this.props

    if (error) return <LoadingError />
    if (!searchTerm) return <LoadingWheel />

    const ccn = 'search'
    const pageCcn = 'page'
    const pagePrev = parseInt(searchPageNumber, 10) - 1
    const pageNext = parseInt(searchPageNumber, 10) + 1
    const totalPages = Math.ceil(parseFloat(searchTotalResults / conf.SEARCH_RESULTS_PER_PAGE, 10))
    const metaData = {
      title: 'Help & FAQ - Search Results for "' + searchDecode(searchTerm) + '"'
    }

    return (
      <div className={ccn + ' ' + pageCcn + ' container'}>
        <div id='helpfaqcontent' tabIndex='-1' />
        <Helmet {...metaData} />
        <div className='xs-row xs-row--negative lg-row'>
          <Sidebar links={sidebar} loading={loading} />

          <div className='xs-12 lg-9 content'>
            <SearchBar />
            <h2 className='page__title page__title--search'>{searchTotalResults} search results for: '{searchDecode(searchTerm)}'</h2>
            <div className={ccn + '__results'}>
              {
                searchTotalResults > 0 && searchResults.map((result, index) => {
                  let formattedAnswer = marked(result.answer)
                  formattedAnswer = formattedAnswer.replace(/<(?:.|\n)*?>/gm, '').replace(/#/g, '').replace(/\*/g, '').replace(/&39;/g, '\'')
                  return (
                    <Link className={ccn + '__link ' + ccn + '__link--' + index} to={'/help/faq/' + result.id + '?search=' + this.props.searchTerm} key={index} aria-label={result.question}>
                      <h6 className={ccn + '__title'}>{result.question}</h6>
                      <p className={ccn + '__desc'}>
                        <span dangerouslySetInnerHTML={{ __html: truncate(formattedAnswer, 150) }} />
                        <span className={ccn + '__readmore'}>Read more</span>
                      </p>
                    </Link>
                  )
                })
              }
              {
                totalPages > 0 &&
                  <nav className={ccn + '__pagination'}>
                    {
                      pagePrev !== 0 &&
                      <Link className={ccn + '__button'} to={'/help/search/' + searchTerm + '/' + pagePrev}>
                        <span className='argos-icon icon-UIE-Controls-Chevron-Left' aria-hidden='true' />
                        <span className='sr-only'>Previous</span>
                      </Link>
                    }
                    <span className={ccn + '__page-number'}>Page {searchPageNumber} of {totalPages}</span>
                    {
                      pageNext <= totalPages &&
                      <Link className={ccn + '__button'} to={'/help/search/' + searchTerm + '/' + pageNext}>
                        <span className='argos-icon icon-UIE-Controls-Chevron-Right' aria-hidden='true' />
                        <span className='sr-only'>Next</span>
                      </Link>
                    }
                  </nav>
              }
              {
                searchTotalResults === 0 &&
                <p className={ccn + '__no-results-message'}>The term you chose confused our site<br />We'd really like to put things right<br />So please do try a different word<br />A simpler, clearer one is preferred</p>
              }
            </div>

          </div>
        </div>
      </div>
    )
  }
}

HelpFAQ.propTypes = {
  error: PropTypes.bool,
  sidebar: PropTypes.array,
  searchPageNumber: PropTypes.number,
  searchResults: PropTypes.array,
  searchTerm: PropTypes.string,
  searchTotalResults: PropTypes.number,
  loading: PropTypes.bool,
  actions: PropTypes.object,
  routeParams: PropTypes.object
}

function mapStateToProps (state) {
  return {
    sidebar: state.help.sidebar,
    searchPageNumber: state.faq.searchPageNumber,
    searchResults: state.faq.searchResults,
    searchTerm: state.faq.searchTerm,
    searchTotalResults: state.faq.searchTotalResults,
    error: state.faq.searchError,
    loading: state.faq.searchLoading
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpFAQ)
